export default __webpack_public_path__ + "static/media/T13.b921ecbc.JPG";